import { useState, useCallback } from "react";
import { SimCanvas } from "@/components/SimCanvas";
import { createBall, DEFAULT_CONFIG } from "@/lib/physics";
import type { Ball, PhysicsConfig } from "@/lib/physics";
import { Button } from "@/components/ui/button";

export function Lesson1Gravity() {
	const [balls, setBalls] = useState<Ball[]>(() => [
		createBall(350, 50, 0, 0, 25),
	]);
	const [config, setConfig] = useState<PhysicsConfig>({
		...DEFAULT_CONFIG,
		restitution: 0.85,
	});
	const [gravity, setGravity] = useState(980);

	const reset = () => {
		setBalls([createBall(350, 50, 0, 0, 25)]);
	};

	const handleClick = useCallback((x: number, y: number) => {
		setBalls((prev) => [...prev, createBall(x, y, 0, 0, 15 + Math.random() * 20)]);
	}, []);

	const changeGravity = (g: number) => {
		setGravity(g);
		setConfig((prev) => ({ ...prev, gravity: g }));
	};

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap gap-2">
				<Button variant="outline" size="sm" onClick={() => changeGravity(160)} className={gravity === 160 ? "border-cyan-400 text-cyan-400" : ""}>
					Moon (1.6 m/s²)
				</Button>
				<Button variant="outline" size="sm" onClick={() => changeGravity(370)} className={gravity === 370 ? "border-cyan-400 text-cyan-400" : ""}>
					Mars (3.7 m/s²)
				</Button>
				<Button variant="outline" size="sm" onClick={() => changeGravity(980)} className={gravity === 980 ? "border-cyan-400 text-cyan-400" : ""}>
					Earth (9.8 m/s²)
				</Button>
				<Button variant="outline" size="sm" onClick={() => changeGravity(2480)} className={gravity === 2480 ? "border-cyan-400 text-cyan-400" : ""}>
					Jupiter (24.8 m/s²)
				</Button>
				<Button variant="outline" size="sm" onClick={reset}>
					Reset
				</Button>
			</div>

			<SimCanvas
				balls={balls}
				config={config}
				showTrails
				showEnergy
				onClick={handleClick}
			/>

			<p className="text-sm text-muted-foreground">
				Click anywhere in the simulation to drop a new ball. Watch how gravity changes the fall speed on different planets!
			</p>
		</div>
	);
}
